import {searchQueueEventFields} from '#queries/queue_events/index.js';
import type {QueueEvent} from '#types/queue_events.js';
import type {AudienceBuilderField} from '#lit/types/builders/audience_builder/index.js';
import {ExpressionTypes} from '#lit/types/builders/audience_builder/index.js';
import {MatchFieldSourceType} from '#types/journeys.js';
import {AdditionalFieldKind} from '#lit/utils/additional_fields.js';

export class RealtimeEventService {
  private realtimeEvent?: QueueEvent;

  constructor(realtimeEvent?: QueueEvent) {
    this.realtimeEvent = realtimeEvent;
  }

  setRealtimeEvent(event?: QueueEvent) {
    this.realtimeEvent = event;
  }

  async fetchFields(query?: string): Promise<AudienceBuilderField[]> {
    if (!this.realtimeEvent) {
      return [];
    }

    let response;
    try {
      response = await searchQueueEventFields({
        id: this.realtimeEvent.id,
        query,
      });
    } catch (err) {
      console.error('Failed to fetch realtime fields', err);
      throw err;
    }

    return response.results.map(({id, name, display_name}) => ({
      id,
      name,
      display_name,
      dataset: this.realtimeEvent?.id.toString() ?? '',
      table: this.realtimeEvent?.id.toString() ?? '',
      type: ExpressionTypes.STRING,
      fw_type: ExpressionTypes.STRING,
      computed: false,
      computedFieldId: undefined,
      kind: AdditionalFieldKind.PRIMARY,
      sourceType: MatchFieldSourceType.REALTIME,
    }));
  }
}
